import { createSlice } from '@reduxjs/toolkit';
import { pushDynamicTab } from '../utils/dynamicTabs';

const SLICE_VERSION = '1.2';
const DEFAULT_STATUS_FILTER = 'New';
const DEFAULT_LIST_VIEW_STATE = {
  currentPage: 1,
  itemsPerPage: 50,
};

export const initialState = {
  _version: SLICE_VERSION,

  defaultTabs: [
    { id: 'orders', name: 'Orders', contentType: 'orders' },
  ],

  dynamicTabs: [],
  activeTab: 0,
  statusFilter: DEFAULT_STATUS_FILTER,
  listViewState: {
    "orders-incoming": { ...DEFAULT_LIST_VIEW_STATE },
  },
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,

  reducers: {
    addTab: (state, action) => {
      const payload = action.payload || {};

      const tab = {
        id: payload.id || `dyn-${Date.now()}`,
        name: payload.name || `New Order ${state.dynamicTabs.length + 1}`,
        isDynamic: true,
        createdAt: Date.now(),

        // ⭐ Store ALL fields for matching
        contentType: payload.contentType || null,
        orderNumber: payload.orderNumber || null,
        orderOfficeCode: payload.orderOfficeCode || null,
        searchQuery: payload.searchQuery || null,
        appointmentData: payload.appointmentData || null,
      };

      pushDynamicTab(state, tab, state.defaultTabs.length);
    },

    removeTab: (state, action) => {
      const { tabIndex } = action.payload;
      if (tabIndex < state.defaultTabs.length) return;

      const dynamicIndex = tabIndex - state.defaultTabs.length;
      state.dynamicTabs.splice(dynamicIndex, 1);

      // Snap back to the default Orders tab after closing any dynamic tab
      state.activeTab = 0;
    },

    setActiveTab: (state, action) => {
      const { id, index } = action.payload;

      if (id) {
        const tabs = [...state.defaultTabs, ...state.dynamicTabs];
        const idx = tabs.findIndex((t) => t.id === id);
        if (idx !== -1) {
          state.activeTab = idx;
          return;
        }
      }

      if (index != null) {
        const total = state.defaultTabs.length + state.dynamicTabs.length;
        if (index >= 0 && index < total) {
          state.activeTab = index;
        }
      }
    },

    resetTabs: (state) => {
      state.dynamicTabs = [];
      state.activeTab = 0;
    },
    setStatusFilter: (state, action) => {
      state.statusFilter = action.payload;
    },
    setListViewState: (state, action) => {
      const { stateKey = "orders-incoming", ...rest } = action.payload || {};
      const existing = state.listViewState[stateKey] || {
        ...DEFAULT_LIST_VIEW_STATE,
      };
      state.listViewState[stateKey] = {
        ...existing,
        ...rest,
      };
    },
  },
});

export const { addTab, removeTab, setActiveTab, resetTabs, setStatusFilter, setListViewState } =
  ordersSlice.actions;

export default ordersSlice.reducer;